<template>
  <hic-dialog append-to-body v-if="value" :close-on-click-modal="false" :visible="visible" width="50rem" @open="open" :title="'科室编辑'" @close="cancel">
    <el-form class="left" :model="value" :rules="comRules" ref="editor" :inline="true" label-width="120px">
      <el-form-item label="科室职能">
        <hic-dict-selector  class="edit-nomal" :disabled="!!value.parentName" dict-type="DeptType" @change="typeChange"  is-enum v-model="value.deptType" />
      </el-form-item>
      <el-form-item v-if="value.deptType == Enum.DeptType.临床" label="一级分类">
       <hic-dict-selector :disabled="!!value.parentName" class="edit-nomal" dict-type="DeptStandard" v-model="value.standardDeptCode"   />
      </el-form-item>
      <el-form-item label="科室名称" prop="name">
        <el-input type="text" placeholder="请输入科室名称" v-model.trim="value.name" class="edit-nomal"></el-input>
      </el-form-item>
      <el-form-item label="科室编码" prop="code">
        <el-input type="text" placeholder="请输入科室编码" v-model.trim="value.code" :disabled="!!value.id" class="edit-nomal" />
      </el-form-item>
      <el-form-item label="上级科室">
        
        <hic-dept-selector  class="edit-nomal" v-model="value.parentCode" />
        
      </el-form-item>
      <el-form-item label="排序" prop="seqNo">
        <el-input type="number" placeholder="请输入排序" v-model.number="value.seqNo" class="edit-nomal" />
      </el-form-item>

      <el-form-item label="性别限制" prop="gender">
            <hic-dict-selector  class="edit-nomal" dict-type="Gender" v-model="value.gender"  />
      </el-form-item>

      <el-form-item label="年龄限制" prop="age">
        <el-input type="number" placeholder="请输入限制年龄" v-model.number="value.age" class="edit-nomal" />
        <!-- <el-input-number v-model="value.age"  :min="1" :max="999" label="请输入限制年龄"></el-input-number> -->
      </el-form-item>

      <el-form-item label="科室位置" prop="location">
        <el-input type="text" placeholder="请输入科室位置" v-model.number="value.location" class="edit-nomal" />
        <!-- <el-input-number v-model="value.age"  :min="1" :max="999" label="请输入限制年龄"></el-input-number> -->
      </el-form-item>

      <el-form-item v-if="value.deptType == Enum.DeptType.临床" label="临床类别">
        <div class="edit-nomal">
          <div style="display: flex">
            <el-checkbox v-model="value.ifOp" label="门诊"></el-checkbox>
            <el-checkbox v-model="value.ifIp" label="住院"></el-checkbox>
            <el-checkbox v-model="value.ifEmrg" label="急诊"></el-checkbox>
          </div>
        </div>
      </el-form-item>
      <el-form-item v-if="value.deptType == Enum.DeptType.临床 || value.deptType == Enum.DeptType.医技" label="医技类别">
        <div class="edit-nomal">
          <div style="display: flex">
            <el-checkbox v-model="value.ifExamine" label="检验"></el-checkbox>
            <el-checkbox v-model="value.ifCheck" label="检查"></el-checkbox>
            <el-checkbox v-model="value.ifTreat" label="治疗"></el-checkbox>
          </div>
        </div>
      </el-form-item>

      <el-form-item v-if="value.deptType == Enum.DeptType.临床 || value.deptType == Enum.DeptType.医技" label="执行科室">
        <div class="el-select edit-nomal">
          <div style="display: flex; justify-content: center">
            <el-switch v-model="value.ifExeDept" active-text="是" inactive-text="否"></el-switch>
          </div>
        </div>
      </el-form-item>

      <el-form-item v-if="value.deptType == Enum.DeptType.临床 || value.deptType == Enum.DeptType.医技" label="生育险">
        <div class="el-select edit-nomal">
          <div style="display: flex; justify-content: center">
            <el-switch v-model="value.ifMaternityInsurance" active-text="是" inactive-text="否"></el-switch>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="cancel">关 闭</el-button>
      <el-button type="primary" @click="save" :disabled="disabledSave">确 定</el-button>
    </div>
  </hic-dialog>
</template>
<script>
import api from './api';
import { mapGetters } from 'sw-hic';
export default {
  props: {
    visible: Boolean,
    value: Object,
    allDepts: Array,
  },
  data() {
    var validateCode = (rule, value, callback) => {
      if (!/^[0-9a-zA-Z_-]*$/.test(value)) {
        return callback(new Error('编码只能包含：【大小写字母】【数字】【_】【-】'));
      }
      return callback();
    };
    return {
      comRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { max: 128, message: '名称长度在 128 个字符以内', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入编码', trigger: 'blur' },
          { max: 64, message: '编码长度在 64 个字符以内', trigger: 'blur' },
          // { validator: validateCode, trigger: "blur" }
        ],
        standardDeptCode: [
          { required: true, message: '请输入编码', trigger: 'blur' },
          { max: 64, message: '编码长度在 64 个字符以内', trigger: 'blur' },
          { validator: validateCode, trigger: 'blur' },
        ],
        seqNo: [
          {
            required: false,
            type: 'number',
            message: '排序只允许是数字',
            trigger: 'blur',
          },
        ],
      },
      loading: false,
      disabledSave: false,
    };
  },
  computed: {
    ...mapGetters(['dict', 'Enum']),
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
    },
    typeChange() {
      this.value.parentCode = null;
      if (this.value.deptType !== this.Enum.DeptType.临床) {
        this.value.treatType = [];
        this.value.ifExeDept = false;
      }
    },
    save() {
      let _this = this;
      this.$refs.editor
        .validate()
        .then(valid => {
          _this.disabledSave = true;
          if (_this.value.parentCode) {
            if (_this.value.parentCode == _this.value.code) {
              throw '科室的上级不能是自己！';
            }
            let parent = _this.allDepts.find(item => item.code == _this.value.parentCode);

            if (parent && parent.codeChain.indexOf(`@${_this.value.code}@`) >= 0) {
              throw '科室的上级不能是下级！';
            }
          }
          if (_this.value.deptType != this.Enum.DeptType.临床) {
            _this.value.ifOp = false;
            _this.value.ifIp = false;
            _this.value.ifEmrg = false;
          }
          if (_this.value.deptType != this.Enum.DeptType.临床 && _this.value.deptType != this.Enum.DeptType.医技) {
            _this.value.ifExeDept = false;
          }

          return api.Dept.save(_this.value);
        })
        .then(newEntity => {
          _this.disabledSave = false;
          _this.$emit('update:visible', false);
          _this.$emit('ok');
          _this.$message.success('保存成功！');
        })
        .catch(err => {
          _this.disabledSave = false;
          if (err) {
            _this.$message.error(err.message || err);
          }
        });
    },
    open() {
      if (this.$refs.editor) {
        this.$refs.editor.clearValidate();
      }
    },
  },
};
</script>
<style scoped>
.edit-nomal {
  width: 13rem;
}
</style>
